<template>
  <div class="feature">
	<div class="counterScreen">
		<animated-number class="counterText" :value="value" :formatValue="formatToPrice" :duration="duration"/>
		<font-awesome-icon class="counterUser" icon="user"/>
		<h4>USERS REGISTERED TO EVENT</h4>
	</div>
	<h4 class="title"><p>{{feature.title}}</p></h4>
	<div class="blurbText">{{feature.blurb}}</div>
  </div>
</template>


<script>
import AnimatedNumber from './AnimatedNumber.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon}  from '@fortawesome/vue-fontawesome'

export default {
    name: 'FeatureItem',
    props: ['feature'],
    components: {AnimatedNumber, FontAwesomeIcon},
    mounted: function () {
        this.$nextTick(function() {
        this.updateFunc = window.setInterval(() => {this.increase()}, 10);
        })
    },
    beforeDestroy: function() {
        this.$notify({
            group: 'events',
            clean: true
        });

        window.clearInterval(this.updateFunc);
    },
    data() {
        return {
            value: 10000,
            duration: 0,
            stopAt: 0,
            switchDuration: true,
            updateFunc: null
        }
    },
    methods: {
        formatToPrice(value) {
            return `${value.toFixed(0)}`;
        },
        increase() {

            if(this.switchDuration)
            {
                this.duration = 2000;
            }

            if(this.stopAt < 2)
            {
                this.switchDuration = false;
                this.value = Number(this.value) + 2550;
                this.stopAt++;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.feature {
	border: 1px solid $darkblue;
	margin: 1%;
	padding-bottom: 1%;
}
.featureImg {
	width: 100%;
	height: 150px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
}
.title {
	//background-color: $darkblue;
	color: white;
    color: black;
    display: flex;
	justify-content: center;
    
    p {
        margin: 0;
		padding-bottom: 0.8rem;
		border-bottom: $blue 2px solid;
	}
}
.blurbText {
	padding-bottom: 1rem;
	padding-right: 1rem;
	padding-left: 1rem;
}
.groupItem {
	width: 50%;
	// margin: 1%;
}
.counterScreen {
    // padding-top: 3%;
    height: 260px;
	// border: solid 1px $darkblue;
	background-color: $blue;
}
.counterText {
	position: absolute;
  	font-size: 2rem;
  	color: black;
  	transform: translate(25px,280%);
  	-ms-transform: translate(-100%,-100%);
}
.counterUser {
    padding-top: 1rem;
	font-size: 10rem;
	color: white;
}
.featureList {
        display: flex;
        flex-direction: column;
		flex-wrap: wrap;
        justify-content: flex-start;
}
.featureItem {
	width: 100%;
}
</style>
